module.exports = "https://cdn.thelire.com/ins/resource/coins.30ec1cd760f361c9e2da4e61f1e8f623.png";